<template>
	<DashCard
		title="Overview"
		:loading="loading"
		:has-error="hasError"
		:no-data="noLoadedData"
		:info-data="infoData"
		info-data-title="Advance: Agency Dashboard. Overview"
		@reload="$emit('reload', 'advance_mad_rollup')"
	>
		<div class="card-content">
			<v-data-table
				:headers="headers"
				:items="computedData"
				:item-key="itemKey"
				:page.sync="computedOptions.page"
				:items-per-page.sync="computedOptions.itemsPerPage"
				:sort-by.sync="computedOptions.sortBy"
				:sort-desc.sync="computedOptions.sortDesc"
				:server-items-length="serverItemsLength"
				:footer-props="{
					itemsPerPageOptions: [7, 25, 50, 100],
					itemsPerPageText: isMobileView ? '' : 'Rows per page',
				}"
				:hide-default-footer="noLoadedData || !serverItemsLength"
				fixed-header
				dark
				:mobile-breakpoint="0"
				class="advance__agency-dashboard-table"
			>
				<template #item="{ item }">
					<tr :class="isHighlighted(item)">
						<td v-for="h in headers" :key="`${h.value}-${item.AgentCode}`">
							<span
								v-if="h.value === 'AgentName'" :key="h.value"
								class="nowrap advance__agency-dashboard-table__item"
								:class="item.AgentCode && 'advance__agency-dashboard-table__item--link'"
								@click.stop="() => selectAgent(item)"
							>
								{{ item[h.value] || 'NA' }}
							</span>
							<span v-else :key="h.value">
								<template v-if="isCurrency(h.value)">
									<span v-if="Number(item[h.value]) < 0">-</span>
									<span class="with-currency">{{ formatMoney(item[h.value]) }}</span>
								</template>
								<template v-else>{{ formatNumberItem(item[h.value]) }}</template>
							</span>
						</td>
					</tr>
				</template>
				<!-- <template v-slot:body.append>
					<tr>
						<th v-for="item in summaries" :key="item.key" class="advance__agency-dashboard-table__summaries">
							<template v-if="item.key === 'AgentName'" />
							<template v-else-if="isCurrency(item.key)">
								<span v-if="Number(item.sum) < 0">-</span>
								<span class="with-currency">{{ formatMoney(item.sum) }}</span>
							</template>
							<template v-else>{{ formatNumberItem(item.sum) }}</template>
						</th>
					</tr>
				</template> -->
			</v-data-table>
		</div>
	</DashCard>
</template>

<script>
import DashCard from '../DashCard.vue'

import { overviewConfig as config, getEmptyData } from '../../config/agencyDashboard'

export default {
    components: {
		DashCard,
	},
	props: {
		data: {
			type: Object,
			default: null,
		},
		selectedAgent: {
			type: Object,
			default: null,
		},
		// summariesData: {
		// 	type: Object,
		// 	default: null,
		// },
		options: {
			type: Object,
			required: true,
		},
		serverItemsLength: {
			type: Number,
			default: -1,
		},
		infoData: Object,
	},
	data () {
		return {
			itemKey: 'AgentID',
		}
	},
    computed: {
		computedOptions: {
			get () { return this.options },
			set (v) { this.$emit('update-options', v) },
		},
		isMobileView () {
			return this.$vuetify.breakpoint.xs
		},
		loading () {
			if (!this.data) { return false }
			return this.data.loading
		},
		hasError () {
			if (!this.data) { return false }
			return this.data.error
		},
		noLoadedData () {
			if (this.data && this.data.loaded) {
				if (!this.data.data) { return true }
				return this.data.data.every((item) => {
					return config.every(({ key }) => this.checkNullish(item[key]))
				})
			}
			return false
		},
		computedData () {
			let data = getEmptyData(this.itemKey)
			if (this.data && this.data.loaded && !this.noLoadedData) {
				data = this.data.data
			}
			return data
		},
		headers () {
			return config.map((item) => ({
				text: item.label,
                value: item.key,
				sortable: Boolean(item.sortable),
				class: 'nowrap',
			}))
		},
		// summaries () {
		// 	return config.map(({ key }) => {
		// 		if (key === 'AgentName') { return { key } }
		// 		const sum = this.summariesData?.data?.[key] || ''
		// 		return { key, sum }
		// 	})
		// },
    },
	methods: {
		selectAgent (agent) {
			if (!agent?.AgentCode) { return }
			this.$emit('select-agent', agent)
		},
		checkNullish (value) {
			return [undefined, null, ''].includes(value)
		},
		formatNumberItem (value) {
			const isNullish = this.checkNullish(value)
			if (isNullish) { return 'NA' }
			return this.formatNumber(value, '0,0')
		},
		formatMoney (value) {
			if (this.checkNullish(value)) { return 'NA' }
			return this.formatNumber(Math.abs(value), '0,0[.]00')
		},
		isCurrency (key) {
			return config.find((item) => item.key === key)?.type === 'currency'
		},
		isHighlighted (item) {
			return item.AgentCode === this.selectedAgent?.AgentCode
				? 'perform-dash-overview__highlighted-row'
				: undefined
		},
	},
}
</script>

<style lang="scss" scoped>
@import '../../style/index.scss';

.dash-card {
	--card-bg: #001C50;

	margin-left: -1rem;
	margin-right: -1rem;
	padding: 0.5rem 1.5rem 1.5rem;

	&--mobile {
		margin-left: -0.5rem;
		margin-right: -0.5rem;
		padding: 0.5rem 1rem 1.5rem;
	}

	::v-deep .dash-card__content {
		min-height: 9rem;
	}

	::v-deep .dash-card__header {
		min-height: 2rem;
	}
}

// .advance__agency-dashboard-table {
// 	::v-deep .v-data-table__wrapper {
// 		max-height: 304px;
// 	}
// }
</style>
